import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { complianceDocs as fallbackComplianceDocs } from '../data/siteData';
import { getContentIcon, useCollectionData } from '../services/contentApi';
import './Footer.css';

const footerGroups = [
  {
    title: 'Products',
    links: [
      ['Bed sheets & fitted sheets', '/products'],
      ['Pillowcases', '/products'],
      ['Bath & hand towels', '/products'],
      ['OR surgical towels', '/products'],
      ['Patient gowns', '/products'],
      ['Non-woven disposables', '/products'],
    ],
  },
  {
    title: 'Solutions',
    links: [
      ['Hospitals & health systems', '/solutions'],
      ['Long-term care facilities', '/solutions'],
      ['Diagnostic & specialty clinics', '/solutions'],
      ['Surgical & OR centers', '/solutions'],
      ['GPO partnerships', '/solutions#procurement'],
      ['Custom branding', '/solutions#procurement'],
    ],
  },
  {
    title: 'Compliance',
    links: [
      ['CDC guidelines', '/compliance'],
      ['OSHA standards', '/compliance'],
      ['HLAC accreditation', '/compliance'],
      ['FDA textile standards', '/compliance'],
      ['Resource library', '/resources'],
      ['Request documentation', '/contact'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['Why NovaCareLinens', '/solutions#procurement'],
      ['Blog & resources', '/resources'],
      ['Request a quote', '/contact'],
      ['Account portal', '/contact'],
      ['Partnerships', '/contact'],
      ['Compliance statement', '/compliance'],
    ],
  },
];

const Footer = () => {
  const { items: complianceDocs } = useCollectionData('complianceDocs', fallbackComplianceDocs);

  return (
  <footer className="footer">
    <div className="container">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="NovaCareLinens home">
            <img
              src="/logo.png"
              alt="NovaCareLinens logo"
              className="brand-logo brand-logo--footer"
            />
          </Link>
          <p className="footer-tagline">
            Specialized towel and bed sheet provider for healthcare facilities.
          </p>
          <p className="footer-mission">
            Deliver durable, soft, infection-control-grade linens that enhance
            patient comfort while supporting regulatory compliance and
            operational efficiency.
          </p>
          <div className="footer-contact">
            <a href="mailto:procurement@novacarelinens.com" className="footer-contact-link">
              <Mail size={16} aria-hidden="true" /> procurement@novacarelinens.com
            </a>
            <a href="tel:180074554636" className="footer-contact-link">
              <Phone size={16} aria-hidden="true" /> 1-800-NCL-LINEN
            </a>
          </div>
        </div>

        <div className="footer-links-group">
          {footerGroups.map((group) => (
            <div className="footer-col" key={group.title}>
              <h4>{group.title}</h4>
              <ul>
                {group.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer-docs" aria-label="Compliance document shortcuts">
        {complianceDocs.map((doc, index) => {
          const Icon = getContentIcon(doc.icon);
          return (
            <a className="footer-doc" href={doc.href || doc.fileUrl} download key={doc.title || index}>
              <Icon size={16} aria-hidden="true" />
              {doc.title}
            </a>
          );
        })}
      </div>

      <div className="footer-bottom">
        <span>Copyright 2026 NovaCareLinens. All rights reserved.</span>
        <div className="footer-legal">
          <Link to="/contact">Privacy policy</Link>
          <Link to="/contact">Terms of service</Link>
          <Link to="/compliance">Compliance statement</Link>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
